var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomWave4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1620,
    height: 160,
    viewBox: "0 0 1620 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1620 41.4815C1620 41.4815 1485.5 -51.8519 810 41.4815C134.5 134.815 0 41.4815 0 41.4815V160H1620V41.4815Z",
    fill: "#0B2878"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomWave4);
export default __webpack_public_path__ + "static/media/bottomWave4.ed86987b0c59e06bbdd2fc400cedc48f.svg";
export { ForwardRef as ReactComponent };